export const EMPLOYEE_SET_ACTIVE_POSITION = 'EMPLOYEE_SET_ACTIVE_POSITION';
export const EMPLOYEE_SET_PAINTROOM = 'EMPLOYEE_SET_PAINTROOM';
